import { render, staticRenderFns } from "./request-icon.vue?vue&type=template&id=282cbf3b&scoped=true"
import script from "./request-icon.vue?vue&type=script&lang=js"
export * from "./request-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cbf3b",
  null
  
)

export default component.exports